import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { setLoading } from "../loading/loadingSlice";
import { setError, clearError } from "../error/errorSlice";

import {
  fetchCustomers as fetchCustomerWithSort,
  fetchAllCustomers as fetchAllCustomersFromAPI,
} from "../../pages/setup/components/Customer/services/customerService";

const initialState = {
  customers: [],
  allCustomers: [],
  loading: false,
  error: null,
  totalPages: 1,
};

export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async (
    { currentPage, rowsPerPage, searchQuery, sortField, sortOrder },
    thunkAPI
  ) => {
    const { dispatch } = thunkAPI;
    try {
      // dispatch(setLoading(true));
      dispatch(clearError());
      const data = await fetchCustomerWithSort(
        currentPage,
        rowsPerPage,
        searchQuery,
        sortField,
        sortOrder
      );
      return data;
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    }
    // finally {
    //   dispatch(setLoading(false));
    // }
  }
);

export const fetchAllCustomers = createAsyncThunk(
  "customers/fetchAllCustomers",
  async (_, thunkAPI) => {
    const { dispatch } = thunkAPI;
    try {
      // dispatch(setLoading(true));
      dispatch(clearError());
      const data = await fetchAllCustomersFromAPI();
      return data; // expecting an array of customers
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    }
    // finally {
    //   dispatch(setLoading(false));
    // }
  }
);

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload.content;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllCustomers.fulfilled, (state, action) => {
        state.allCustomers = action.payload;
      });
  },
});

export const selectCustomers = (state) => state.customers.customers;
export const selectAllCustomers = (state) => state.customers.allCustomers;
export const selectTotalPages = (state) => state.customers.totalPages;
export const selectLoading = (state) => state.customers.loading;

export default customerSlice.reducer;
